
import imageCompression from 'browser-image-compression';
import store from './vuex/store.js';

function isFileImage(file) {
    return file && file['type'].split('/')[0] === 'image';
}

async function compressMultipleFiles(files){
    var compressedFilesArr = [];
    for (let index = 0; index < files.length; index++) {
        var compressedFile = await compressFile(files[index])
        compressedFilesArr.push(compressedFile)
    }

    
    return compressedFilesArr
    
}

async function compressFile(file){
    if(!isFileImage(file))
        return file;
        var config = store.getters.config
        var maxSizeKb = config.max_record_size
    const options = {
        maxSizeMB: maxSizeKb/1024,
        maxWidthOrHeight: 1080,
        useWebWorker: false
      }

      try {
        const compressedFile = await imageCompression(file, options);
        
        return compressedFile
        
      } catch (error) {
        console.log(error);
        return file
      }

   
}

function validateFileSizes(files){

  
  var config = store.getters.config
  var maxSize = config.max_record_size
  
  var isValid = true
  for (let index = 0; index < files.length; index++) {
    var f = files[0];
    
    var sizeInkb = (f.size / 1024)        
    if(sizeInkb > maxSize)
      {
        isValid = false
        break
      }
    
  }

    return isValid;

}

export { compressMultipleFiles, validateFileSizes };